module.exports = require("core-js/modules/es.object.to-string.js");